import { withTranslation } from '@application/i18n/with_translation';
import { CellulaFormSubmitData, Flex, Form, InputTextArea, Spacer } from '@cellula/react';
import { tokens } from '@cellula/react-theme-patient';
import { Title } from '@component/title.component';
import { useResolveController } from '@visiba/instantiation';
import { ViewAnonymousChatController } from '../view_anonymous_chat.controller';

export function ScreenInitialMessage() {
	const controller = useResolveController(ViewAnonymousChatController);

	async function handleSubmit(data: CellulaFormSubmitData) {
		const formData = data as { message: string };
		await controller.startChat(formData.message);
	}

	return (
		<Form.Root onSubmit={handleSubmit} options={{ mode: 'onSubmit' }}>
			<Flex grow='1' gap={tokens.spacing.x2}>
				<Title title={withTranslation('View.AnonymousChat.ScreenInitialMessage.Title')} />
				<Spacer vertical={tokens.spacing.x0_5} />
				<Flex>
					<InputTextArea
						name='message'
						label={withTranslation('View.AnonymousChat.ScreenInitialMessage.Input.Label.Message')}
						defaultValue={controller.state.value.initialMessage ?? ''}
						onChange={(event) => controller.setInitialMessage(event.target.value)}
						minHeight={200}
						options={{
							required: withTranslation('View.AnonymousChat.ScreenInitialMessage.Input.Validation.Required.Message'),
							minLength: {
								value: 2,
								message: withTranslation('View.AnonymousChat.ScreenInitialMessage.Input.Validation.MinLength.Message', {
									minLength: '2',
								}),
							},
							maxLength: {
								value: 4000,
								message: withTranslation('View.AnonymousChat.ScreenInitialMessage.Input.Validation.MaxLength.Message', {
									maxLength: '4000',
								}),
							},
						}}
					/>
				</Flex>
				<Form.Error />
				<Flex grow='1' justify='end'>
					<Form.SubmitButton variant='primary' size='large'>
						{withTranslation('View.AnonymousChat.ScreenInitialMessage.Button.Send')}
					</Form.SubmitButton>
				</Flex>
			</Flex>
		</Form.Root>
	);
}
